import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { FETCH_COLLECTION_INFO } from 'modules/collections';
import { FETCH_RELATED_SERVICES } from 'modules/related-services';
import { BATHROOM_PDP_LANDING_NAME } from 'landings';
import { BathroomPdpRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/${BATHROOM_PDP_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  store.dispatch(FETCH_COLLECTION_INFO.success, state.collections.collectionInfo ?? undefined);
  store.dispatch(FETCH_RELATED_SERVICES.success, state.relatedServices.serviceList ?? undefined);

  return remoteProps => <BathroomPdpRemote router={router} store={store} {...remoteProps} />;
});
